/** Resolve href for a social link row (WhatsApp uses server env number + draft message) */
export function resolveSocialHref(link, whatsapp) {
  if (link?.platform === 'whatsapp') return whatsapp?.chatUrl || '';
  return String(link?.url || '').trim();
}

export function isSocialLinkActive(link, whatsapp) {
  if (link?.enabled === false) return false;
  if (link?.platform === 'whatsapp') return Boolean(whatsapp?.chatUrl);
  return Boolean(String(link?.url || '').trim());
}

export default { resolveSocialHref, isSocialLinkActive };
